export function classNames(...classes: string[]): string {
    return classes.filter(Boolean).join(" ");
}

const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export const generateRandomString = (length: number): string => {
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const getUpToChar = (str: string, char: string): string => {
    const index = str.indexOf(char);
    if (index === -1) {
        return str;
    }
    return str.substring(0, index);
};

// export const flattenObject = (obj: any, prefix = "", separator = ".") => {
//     return Object.entries(obj).reduce((acc, [key, value]) => {
//         const newKey = prefix ? `${prefix}${separator}${key}` : key;
//
//         if (typeof value === "object" && value !== null) {
//             if (Array.isArray(value)) {
//                 acc[newKey] = JSON.stringify(value); // Convert arrays to strings
//             }
//             else {
//                 Object.assign(acc, flattenObject(value, newKey, separator)); // Recurse for nested objects
//             }
//         }
//         else {
//             acc[newKey] = value;
//         }
//
//         return acc;
//     }, {});
// };

export const colorizeJson = (
    json: any,
    colors = {
        key: "\x1b[32m",     // Green
        value: "\x1b[36m",   // Cyan
        string: "\x1b[33m",  // Yellow
        number: "\x1b[35m",  // Magenta
        boolean: "\x1b[34m", // Blue
        null: "\x1b[31m",    // Red
        reset: "\x1b[0m"     // Reset to default
    }
)=> {
    const jsonString = JSON.stringify(json, null, 2);

    // Check if we're in Safari (which doesn't support ANSI colors in console)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari) {
        // Return plain JSON for Safari
        return jsonString;
    }

    return jsonString.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
        (match) => {
            let color = colors.value;
            if (/^"/.test(match)) {
                color = colors.string;
                if (/:$/.test(match)) {
                    color = colors.key;
                }
            }
            else if (/true|false/.test(match)) {
                color = colors.boolean;
            }
            else if (/null/.test(match)) {
                color = colors.null;
            }
            else if (/^-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?$/.test(match)) {
                color = colors.number;
            }

            return color + match + colors.reset;
        }
    );
};

export const formatSeconds = (totalSeconds: number): string => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};